var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgLike(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16.781 8.883a.469.469 0 01.577-.29l.823.25a3.141 3.141 0 011.892 1.58c.395.766.46 1.639.185 2.456l-.682 2.026h5.216a1.99 1.99 0 011.655 3.088c.888.2 1.553.993 1.553 1.94a1.99 1.99 0 01-1.449 1.913 1.991 1.991 0 01-1.168 3.058A1.99 1.99 0 0123.733 28H15.54a7.17 7.17 0 01-2.63-.497l-.662-.26a1.525 1.525 0 01-1.316.757H4.469A.469.469 0 014 27.531V15.374c0-.259.21-.469.469-.469h6.464c.503 0 .95.246 1.228.624l1.291-.703a4.404 4.404 0 002.037-2.372zm.73.737l-1.14 3.153a5.34 5.34 0 01-2.47 2.876l-1.444.786v1.586a.469.469 0 01-.938 0v-1.592a.587.587 0 00-.586-.586H4.938v11.22h5.995a.587.587 0 00.586-.587v-4.757a.469.469 0 01.938 0v4.599l.796.312a6.244 6.244 0 002.288.433h8.191a1.052 1.052 0 000-2.102H21.19a.469.469 0 010-.938h3.723a1.052 1.052 0 000-2.102H21.19a.469.469 0 010-.937h4.822a1.052 1.052 0 000-2.102H21.19a.469.469 0 010-.938h3.602a1.052 1.052 0 000-2.101h-5.869a.469.469 0 01-.444-.619l.89-2.644a2.207 2.207 0 00-.13-1.729 2.208 2.208 0 00-1.331-1.11l-.397-.12zM9.117 23.478c.724 0 1.314.589 1.314 1.313s-.59 1.313-1.314 1.313a1.314 1.314 0 01-1.313-1.313c0-.724.59-1.313 1.313-1.313zm0 .937a.376.376 0 10.001.752.376.376 0 000-.752zm2.871-5.045a.472.472 0 01.469.468.472.472 0 01-.469.469.47.47 0 01-.469-.469.472.472 0 01.469-.468zm12.171-9.217a.469.469 0 010 .938h-2.89a.469.469 0 010-.938zm-9.414-.001a.469.469 0 010 .937h-2.89a.469.469 0 010-.937zm6.945-3.877a.469.469 0 01.663.663L20.99 8.303a.467.467 0 01-.663 0 .469.469 0 010-.663zm-8.03 0a.469.469 0 01.663 0l1.365 1.364a.469.469 0 01-.663.663l-1.364-1.365a.469.469 0 010-.663zm4.347-.525c.26 0 .469.21.469.469v1.14a.469.469 0 01-.938 0V6.22c0-.26.21-.469.47-.469zm0-1.75a.472.472 0 01.469.469.472.472 0 01-.469.469.472.472 0 01-.469-.47.472.472 0 01.47-.468z"
  }));
}

export default SvgLike;